import { Component } from '@angular/core';

@Component({
  selector: 'cambix-web-v2.0-secure-url',
  templateUrl: './secure-url.component.html',
  styleUrls: ['./secure-url.component.scss'],
})
export class SecureURLComponent {}
